import styled from 'styled-components';
import { IColor } from './interface';

const Color = styled.div<IColor>`
  background-color: ${(props) => props.color};
  border: 1px solid ${(props) => props.bordercolor};
  width: 1rem;
  height: 1rem;
  margin-right: 0.5rem;
  border-radius: 0.25rem;
`;

export default Color;
